module.exports = __webpack_public_path__ + "static/img/03.f96d630.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/02-productCenter-tzzM/03.jpg
// module id = cRHv
// module chunks = 1